import { Typography } from 'antd';
import styled from 'styled-components';

export const Title = styled.h3`
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  text-transform: uppercase;
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  color: #000000;
  margin: 0;
`;

export const EllipsisText = styled(Typography.Paragraph)`
  &.ant-typography {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #171a1fff;
    text-align: left;
    margin: 0;
  }
`;
